/** Masque le bloc « taux de change » quand le module Devises n'est pas livré à l'entreprise. */
export function applyDevisesGate(section: HTMLElement, licensed: boolean): void {
  const card = section.querySelector('#devise-eur')?.closest<HTMLElement>('.card');
  if (card) card.style.display = licensed ? '' : 'none';
}
